var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHtlPrinterOutlined = function SvgHtlPrinterOutlined(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5.5 14a1 1 0 0 1-1-1v-1.037h-.9a1.566 1.566 0 0 1-1.146-.513A1.749 1.749 0 0 1 2 10.264v-3c-.003-.438.16-.862.454-1.186A1.561 1.561 0 0 1 3.6 5.564h.9V3.001a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1v2.563h.9a1.563 1.563 0 0 1 1.147.514c.294.325.456.748.453 1.186v3a1.75 1.75 0 0 1-.453 1.186 1.565 1.565 0 0 1-1.147.513h-.9V13a1 1 0 0 1-1 1h-5Zm0-1h5v-3h-5v3Zm6.9-2.037a.552.552 0 0 0 .409-.189.76.76 0 0 0 .191-.51v-3a.758.758 0 0 0-.191-.51.553.553 0 0 0-.409-.19H3.6a.554.554 0 0 0-.409.19.759.759 0 0 0-.191.51v3a.76.76 0 0 0 .191.51.552.552 0 0 0 .409.189h.9V10a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1v.963h.9ZM5.5 5.5h5V3h-5v2.5Z"
  })));
};
export default SvgHtlPrinterOutlined;